// @docs https://[domain]/api/v1/docs
export default {
  List: "/employees",
  Detail: "/employees",
  Update: "/employees",
  Create: "/employees",
  Import: "/employees/import",
  ListShort: "/employees/short",
  AssignToApps: "/employees/assign-to-apps",
  RemoveAccessApps: "/employees/remove-access-apps",
};
